<form [formGroup]="form" class="row">
    <!-- Caso autorizacionTransaccion  -->
    <div class="col-12" >
        <mat-form-field style="width: 100%;" appearance="outline" >
            <mat-label>Descripción</mat-label>
            <textarea matInput placeholder="Descripción de lo observado en la evidencia filmográfica así como en el lugar de hecho..." formControlName="descripcion" ></textarea>
        </mat-form-field>
     </div>
     <div class="col-6 texto">
        <p>Indica N° de Oficio de entrega de evidencia (Formato ggs-gal-correlativo-año)</p>
     </div>
     <div class="col-6">
        <mat-form-field class="wid"  appearance="outline" >
            <mat-label>N° Oficio</mat-label>
            <input formControlName="n_oficio"  matInput>
          </mat-form-field>
     </div>
</form>
